/* eslint @typescript-eslint/explicit-module-boundary-types: 0 */
// Generated by build-products.mjs – DO NOT EDIT BY HAND.

import type { FileSystemImport } from "~/queries/schema/schema-general";
import type { Params } from "scenes/sceneTypes";
import type { WorkflowsSceneTab } from "../../products/workflows/frontend/WorkflowsScene";
import {
  ActionType,
  DashboardType,
  FileSystemIconColor,
  InsightSceneSource,
  InsightShortId,
  InsightType,
  RecordingUniversalFilters,
  ReplayTabs,
} from "./types";
import { AlertType } from "lib/components/Alerts/types";
import {
  DashboardFilter,
  ExperimentMetric,
  FileSystemIconType,
  HogQLFilters,
  HogQLVariable,
  Node,
  NodeKind,
  ProductKey,
  TileFilters,
} from "~/queries/schema/schema-general";
import { FEATURE_FLAGS, INSIGHT_VISUAL_ORDER } from "lib/constants";
import { SurveysTabs } from "scenes/surveys/surveysLogic";
import { combineUrl } from "kea-router";
import {
  isDataTableNode,
  isDataVisualizationNode,
  isHogQLQuery,
} from "~/queries/utils";
import { toParams } from "lib/utils";
import { urls } from "scenes/urls";

/** This const is auto-generated, as is the whole file */
export const productScenes: Record<string, () => Promise<any>> = {
  Actions: () => import("../../products/actions/frontend/pages/Actions"),
  Action: () => import("../../products/actions/frontend/pages/Action"),
  NewAction: () => import("../../products/actions/frontend/pages/Action"),
  CustomerAnalytics: () =>
    import("../../products/customer_analytics/frontend/CustomerAnalyticsScene"),
  CustomerAnalyticsConfiguration: () =>
    import(
      "../../products/customer_analytics/frontend/scenes/CustomerAnalyticsConfigurationScene/CustomerAnalyticsConfigurationScene"
    ),
  DataWarehouse: () =>
    import("../../products/data_warehouse/DataWarehouseScene"),
  EarlyAccessFeatures: () =>
    import("../../products/early_access_features/frontend/EarlyAccessFeatures"),
  EarlyAccessFeature: () =>
    import("../../products/early_access_features/frontend/EarlyAccessFeature"),
  EndpointsScene: () =>
    import("../../products/endpoints/frontend/EndpointsScene"),
  EndpointsUsage: () =>
    import("../../products/endpoints/frontend/EndpointsUsage"),
  EndpointScene: () =>
    import("../../products/endpoints/frontend/EndpointScene"),
  ErrorTracking: () =>
    import(
      "../../products/error_tracking/frontend/scenes/ErrorTrackingScene/ErrorTrackingScene"
    ),
  ErrorTrackingIssue: () =>
    import(
      "../../products/error_tracking/frontend/scenes/ErrorTrackingIssueScene/ErrorTrackingIssueScene"
    ),
  ErrorTrackingIssueFingerprints: () =>
    import(
      "../../products/error_tracking/frontend/scenes/ErrorTrackingFingerprintsScene/ErrorTrackingIssueFingerprintsScene"
    ),
  ErrorTrackingConfiguration: () =>
    import(
      "../../products/error_tracking/frontend/scenes/ErrorTrackingConfigurationScene/ErrorTrackingConfigurationScene"
    ),
  Game368Hedgehogs: () =>
    import("../../products/games/368Hedgehogs/368Hedgehogs"),
  FlappyHog: () => import("../../products/games/FlappyHog/FlappyHog"),
  Links: () => import("../../products/links/frontend/LinksScene"),
  Link: () => import("../../products/links/frontend/LinkScene"),
  LiveDebugger: () =>
    import("../../products/live_debugger/frontend/LiveDebugger"),
  LLMAnalytics: () =>
    import("../../products/llm_analytics/frontend/LLMAnalyticsScene"),
  LLMAnalyticsTrace: () =>
    import("../../products/llm_analytics/frontend/LLMAnalyticsTraceScene"),
  LLMAnalyticsSession: () =>
    import("../../products/llm_analytics/frontend/LLMAnalyticsSessionScene"),
  LLMAnalyticsUsers: () =>
    import("../../products/llm_analytics/frontend/LLMAnalyticsUsers"),
  LLMAnalyticsPlayground: () =>
    import("../../products/llm_analytics/frontend/LLMAnalyticsPlaygroundScene"),
  LLMAnalyticsDatasets: () =>
    import(
      "../../products/llm_analytics/frontend/datasets/LLMAnalyticsDatasetsScene"
    ),
  LLMAnalyticsDataset: () =>
    import(
      "../../products/llm_analytics/frontend/datasets/LLMAnalyticsDatasetScene"
    ),
  LLMAnalyticsEvaluations: () =>
    import("../../products/llm_analytics/frontend/LLMAnalyticsScene"),
  LLMAnalyticsEvaluation: () =>
    import(
      "../../products/llm_analytics/frontend/evaluations/LLMAnalyticsEvaluation"
    ),
  LLMAnalyticsEvaluationTemplates: () =>
    import(
      "../../products/llm_analytics/frontend/evaluations/EvaluationTemplates"
    ),
  Logs: () => import("../../products/logs/frontend/LogsScene"),
  ManagedMigration: () =>
    import("../../products/managed_migrations/frontend/ManagedMigration"),
  ManagedMigrationNew: () =>
    import("../../products/managed_migrations/frontend/ManagedMigration"),
  RevenueAnalytics: () =>
    import("../../products/revenue_analytics/frontend/RevenueAnalyticsScene"),
  SessionGroupSummariesTable: () =>
    import(
      "../../products/session_summaries/frontend/SessionGroupSummariesTable"
    ),
  SessionGroupSummary: () =>
    import(
      "../../products/session_summaries/frontend/SessionGroupSummaryScene"
    ),
  TaskTracker: () => import("../../products/tasks/frontend/TaskTracker"),
  TaskDetail: () => import("../../products/tasks/frontend/TaskDetailScene"),
  UserInterviews: () =>
    import("../../products/user_interviews/frontend/UserInterviews"),
  UserInterview: () =>
    import("../../products/user_interviews/frontend/UserInterview"),
  Workflows: () => import("../../products/workflows/frontend/WorkflowsScene"),
  Workflow: () =>
    import("../../products/workflows/frontend/Workflows/WorkflowScene"),
  WorkflowsLibraryTemplate: () =>
    import("../../products/workflows/frontend/TemplateLibrary/MessageTemplate"),
};

/** This const is auto-generated, as is the whole file */
export const productRoutes: Record<string, [string, string]> = {
  "/data-management/actions": ["Actions", "actions"],
  "/data-management/actions/new": ["NewAction", "actionNew"],
  "/data-management/actions/:id": ["Action", "action"],
  "/data-management/actions/new/": ["NewAction", "actionNew"],
  "/customer_analytics": ["CustomerAnalytics", "customerAnalytics"],
  "/customer_analytics/configuration": [
    "CustomerAnalyticsConfiguration",
    "customerAnalyticsConfiguration",
  ],
  "/data-warehouse": ["DataWarehouse", "dataWarehouse"],
  "/early_access_features": ["EarlyAccessFeatures", "earlyAccessFeatures"],
  "/early_access_features/:id": ["EarlyAccessFeature", "earlyAccessFeature"],
  "/endpoints": ["EndpointsScene", "endpoints"],
  "/endpoints/usage": ["EndpointsScene", "endpointsUsage"],
  "/endpoints/:name": ["EndpointScene", "endpoint"],
  "/error_tracking": ["ErrorTracking", "errorTracking"],
  "/error_tracking/configuration": [
    "ErrorTrackingConfiguration",
    "errorTrackingConfiguration",
  ],
  "/error_tracking/:id": ["ErrorTrackingIssue", "errorTrackingIssue"],
  "/error_tracking/:id/fingerprints": [
    "ErrorTrackingIssueFingerprints",
    "errorTrackingIssueFingerprints",
  ],
  "/error_tracking/alerts/:id": ["HogFunction", "errorTrackingAlert"],
  "/error_tracking/alerts/new/:templateId": [
    "HogFunction",
    "errorTrackingAlertNew",
  ],
  "/games/368hedgehogs": ["Game368Hedgehogs", "game368Hedgehogs"],
  "/games/flappyhog": ["FlappyHog", "flappyHog"],
  "/links": ["Links", "links"],
  "/link/:id": ["Link", "link"],
  "/live-debugger": ["LiveDebugger", "liveDebugger"],
  "/llm-analytics": ["LLMAnalytics", "llmAnalytics"],
  "/llm-analytics/dashboard": ["LLMAnalytics", "llmAnalyticsDashboard"],
  "/llm-analytics/generations": ["LLMAnalytics", "llmAnalyticsGenerations"],
  "/llm-analytics/traces": ["LLMAnalytics", "llmAnalyticsTraces"],
  "/llm-analytics/traces/:id": ["LLMAnalyticsTrace", "llmAnalytics"],
  "/llm-analytics/users": ["LLMAnalytics", "llmAnalyticsUsers"],
  "/llm-analytics/errors": ["LLMAnalytics", "llmAnalyticsErrors"],
  "/llm-analytics/sessions": ["LLMAnalytics", "llmAnalyticsSessions"],
  "/llm-analytics/sessions/:id": ["LLMAnalyticsSession", "llmAnalytics"],
  "/llm-analytics/playground": ["LLMAnalytics", "llmAnalyticsPlayground"],
  "/llm-analytics/datasets": ["LLMAnalytics", "llmAnalyticsDatasets"],
  "/llm-analytics/datasets/:id": ["LLMAnalyticsDataset", "llmAnalyticsDataset"],
  "/llm-analytics/evaluations": ["LLMAnalytics", "llmAnalyticsEvaluations"],
  "/llm-analytics/evaluations/templates": [
    "LLMAnalyticsEvaluationTemplates",
    "llmAnalyticsEvaluationTemplates",
  ],
  "/llm-analytics/evaluations/:id": [
    "LLMAnalyticsEvaluation",
    "llmAnalyticsEvaluation",
  ],
  "/llm-analytics/settings": ["LLMAnalytics", "llmAnalyticsSettings"],
  "/logs": ["Logs", "logs"],
  "/managed_migrations": ["ManagedMigration", "managedMigration"],
  "/managed_migrations/new": ["ManagedMigration", "managedMigration"],
  "/revenue_analytics": ["RevenueAnalytics", "revenueAnalytics"],
  "/session-summaries": [
    "SessionGroupSummariesTable",
    "sessionGroupSummariesTable",
  ],
  "/session-summaries/:sessionGroupId": [
    "SessionGroupSummary",
    "sessionGroupSummary",
  ],
  "/tasks": ["TaskTracker", "taskTracker"],
  "/tasks/:taskId": ["TaskDetail", "taskDetail"],
  "/user_interviews": ["UserInterviews", "userInterviews"],
  "/user_interviews/:id": ["UserInterview", "userInterview"],
  "/workflows": ["Workflows", "workflows"],
  "/workflows/:tab": ["Workflows", "workflows"],
  "/workflows/:id/:tab": ["Workflow", "workflowTab"],
  "/workflows/library/templates/:id": [
    "WorkflowsLibraryTemplate",
    "workflowsLibraryTemplate",
  ],
  "/workflows/library/templates/new": [
    "WorkflowsLibraryTemplate",
    "workflowsLibraryTemplate",
  ],
  "/workflows/library/templates/new?messageId=:messageId": [
    "WorkflowsLibraryTemplate",
    "workflowsLibraryTemplateFromMessage",
  ],
};

/** This const is auto-generated, as is the whole file */
export const productRedirects: Record<
  string,
  | string
  | ((params: Params, searchParams: Params, hashParams: Params) => string)
> = {
  "/llm-observability": (_params, searchParams, hashParams) =>
    combineUrl(`/llm-analytics`, searchParams, hashParams).url,
  "/llm-observability/dashboard": (_params, searchParams, hashParams) =>
    combineUrl(`/llm-analytics/dashboard`, searchParams, hashParams).url,
  "/llm-observability/generations": (_params, searchParams, hashParams) =>
    combineUrl(`/llm-analytics/generations`, searchParams, hashParams).url,
  "/llm-observability/traces": (_params, searchParams, hashParams) =>
    combineUrl(`/llm-analytics/traces`, searchParams, hashParams).url,
  "/llm-observability/traces/:id": (params, searchParams, hashParams) =>
    combineUrl(`/llm-analytics/traces/${params.id}`, searchParams, hashParams)
      .url,
  "/llm-observability/users": (_params, searchParams, hashParams) =>
    combineUrl(`/llm-analytics/users`, searchParams, hashParams).url,
  "/llm-observability/playground": (_params, searchParams, hashParams) =>
    combineUrl(`/llm-analytics/playground`, searchParams, hashParams).url,
};

/** This const is auto-generated, as is the whole file */
export const productConfiguration: Record<string, any> = {
  Actions: {
    name: "Actions",
    projectBased: true,
    defaultDocsPath: "/docs/data/actions",
    activityScope: "Action",
    description:
      "Combine several related events into one, which you can then analyze in insights and dashboards as if it were a single event.",
    iconType: "action",
  },
  Action: {
    name: "Action",
    projectBased: true,
    defaultDocsPath: "/docs/data/actions",
    activityScope: "Action",
    iconType: "action",
  },
  NewAction: {
    name: "New Action",
    projectBased: true,
    defaultDocsPath: "/docs/data/actions",
    activityScope: "Action",
    iconType: "action",
  },
  CustomerAnalytics: {
    projectBased: true,
    name: "Customer analytics",
    description: "Understand how your customers interact with your product ",
    iconType: "cohort",
  },
  CustomerAnalyticsConfiguration: {
    projectBased: true,
    name: "Customer analytics configuration",
  },
  DataWarehouse: {
    name: "Data warehouse",
    projectBased: true,
    defaultDocsPath: "/docs/data-warehouse",
    activityScope: "DataWarehouse",
    description:
      "Manage your data warehouse sources and queries. New source syncs are always free for the first 7 days",
    iconType: "data_warehouse",
  },
  SQLEditor: {
    projectBased: true,
    name: "SQL editor",
    defaultDocsPath: "/docs/cdp/sources",
    layout: "app-raw-no-header",
    hideProjectNotice: true,
    description: "Write and execute SQL queries against your data warehouse",
  },
  EarlyAccessFeatures: {
    name: "Early access features",
    projectBased: true,
    defaultDocsPath: "/docs/feature-flags/early-access-feature-management",
    description:
      "Allow your users to individually enable or disable features that are in public beta.",
    iconType: "early_access_feature",
  },
  EarlyAccessFeature: {
    name: "Early access feature",
    projectBased: true,
    defaultDocsPath: "/docs/feature-flags/early-access-feature-management",
  },
  EndpointsScene: {
    projectBased: true,
    name: "Endpoints",
    activityScope: "Endpoints",
    layout: "app-container",
    defaultDocsPath: "/docs/endpoints",
    iconType: "endpoints",
    description:
      "Define queries your application will use via the API and monitor their cost and usage.",
  },
  EndpointsUsage: {
    projectBased: true,
    name: "Endpoints usage",
    activityScope: "Endpoints",
    layout: "app-container",
    iconType: "endpoints",
  },
  EndpointScene: {
    projectBased: true,
    name: "Endpoint",
    activityScope: "Endpoint",
  },
  ErrorTracking: {
    projectBased: true,
    name: "Error tracking",
    defaultDocsPath: "/docs/error-tracking",
    iconType: "error_tracking",
    description:
      "Track and analyze your error tracking data to understand and fix issues.",
  },
  ErrorTrackingIssue: {
    projectBased: true,
    name: "Error tracking issue",
    layout: "app-raw",
  },
  ErrorTrackingIssueFingerprints: {
    projectBased: true,
    name: "Error tracking issue fingerprints",
  },
  ErrorTrackingConfiguration: {
    projectBased: true,
    name: "Error tracking configuration",
  },
  Game368Hedgehogs: {
    name: "368Hedgehogs",
    projectBased: true,
    activityScope: "Games",
  },
  FlappyHog: { name: "FlappyHog", projectBased: true, activityScope: "Games" },
  Links: {
    name: "Links",
    projectBased: true,
    defaultDocsPath: "/docs/link-tracking",
    activityScope: "Link",
    description:
      "Start creating links for your marketing campaigns, referral programs, and more.",
    iconType: "link",
  },
  Link: {
    name: "Link",
    projectBased: true,
    defaultDocsPath: "/docs/link-tracking",
    activityScope: "Link",
  },
  LiveDebugger: { name: "Live Debugger", projectBased: true },
  LLMAnalytics: {
    projectBased: true,
    name: "LLM analytics",
    layout: "app-container",
    defaultDocsPath: "/docs/llm-analytics/installation",
    description: "Analyze and understand your LLM usage and performance.",
    iconType: "llm_analytics",
  },
  LLMAnalyticsTrace: {
    projectBased: true,
    name: "LLM analytics trace",
    layout: "app-container",
    defaultDocsPath: "/docs/llm-analytics/traces",
  },
  LLMAnalyticsSession: {
    projectBased: true,
    name: "LLM analytics session",
    layout: "app-container",
    defaultDocsPath: "/docs/llm-analytics/sessions",
  },
  LLMAnalyticsUsers: {
    projectBased: true,
    name: "LLM analytics users",
    layout: "app-container",
    defaultDocsPath: "/docs/llm-analytics/installation",
  },
  LLMAnalyticsPlayground: {
    projectBased: true,
    name: "LLM playground",
    layout: "app-container",
    defaultDocsPath: "/docs/llm-analytics/installation",
  },
  LLMAnalyticsDatasets: {
    projectBased: true,
    name: "LLM analytics datasets",
    layout: "app-container",
    defaultDocsPath: "/docs/llm-analytics/installation",
  },
  LLMAnalyticsDataset: {
    projectBased: true,
    name: "LLM analytics dataset",
    layout: "app-container",
    defaultDocsPath: "/docs/llm-analytics/installation",
  },
  LLMAnalyticsEvaluations: {
    projectBased: true,
    name: "LLM analytics evaluations",
    activityScope: "LLMAnalytics",
    layout: "app-container",
    defaultDocsPath: "/docs/llm-analytics/installation",
  },
  LLMAnalyticsEvaluation: {
    projectBased: true,
    name: "LLM analytics evaluation",
    activityScope: "LLMAnalytics",
    layout: "app-container",
    defaultDocsPath: "/docs/llm-analytics/installation",
  },
  LLMAnalyticsEvaluationTemplates: {
    projectBased: true,
    name: "LLM analytics evaluation templates",
    activityScope: "LLMAnalytics",
    layout: "app-container",
    defaultDocsPath: "/docs/llm-analytics/installation",
  },
  Logs: {
    projectBased: true,
    name: "Logs",
    activityScope: "Logs",
    layout: "app-container",
    iconType: "logs",
    description: "Monitor and analyze your logs to understand and fix issues.",
    defaultDocsPath: "/docs/logs",
  },
  ManagedMigration: { name: "Managed migrations", projectBased: true },
  ManagedMigrationNew: { name: "Managed migrations", projectBased: true },
  RevenueAnalytics: {
    name: "Revenue Analytics",
    projectBased: true,
    defaultDocsPath: "/docs/revenue-analytics",
    iconType: "revenue_analytics",
    description:
      "Track and analyze your revenue metrics to understand your business performance and growth.",
  },
  SessionGroupSummariesTable: {
    name: "Session summaries",
    projectBased: true,
    description:
      "View and deep-dive into AI-generated summaries of session recordings. Create summaries from the Session replay page by applying filters and asking PostHog AI to summarize sessions.",
    iconType: "notebook",
  },
  SessionGroupSummary: {
    name: "Session summary",
    projectBased: true,
    description: "View detailed session group summary.",
    iconType: "notebook",
  },
  TaskTracker: {
    name: "Tasks",
    projectBased: true,
    defaultDocsPath: "/docs/tasks",
    activityScope: "TaskTracker",
    description:
      "Tasks are work that agents can do for you, like creating a pull request or fixing an issue.",
    iconType: "task",
  },
  TaskDetail: { name: "Task", projectBased: true, activityScope: "TaskDetail" },
  UserInterviews: {
    name: "User interviews",
    projectBased: true,
    activityScope: "UserInterview",
    description: "Record and analyze user interviews with PostHog.",
    iconType: "user_interview",
  },
  UserInterview: {
    name: "User interview",
    projectBased: true,
    activityScope: "UserInterview",
  },
  Workflows: {
    name: "Workflows",
    iconType: "workflows",
    projectBased: true,
    description: "Create and manage your workflows",
  },
  Workflow: { name: "Workflows", iconType: "workflows", projectBased: true },
  WorkflowsLibraryTemplate: {
    name: "Workflows",
    iconType: "workflows",
    projectBased: true,
  },
};

/** This const is auto-generated, as is the whole file */
export const productUrls = {
  createAction: (): string => `/data-management/actions/new`,
  duplicateAction: (action: ActionType | null): string => {
    const queryParams = action
      ? `?copy=${encodeURIComponent(JSON.stringify(action))}`
      : "";
    return `/data-management/actions/new/${queryParams}`;
  },
  action: (id: string | number): string => `/data-management/actions/${id}`,
  actions: (): string => "/data-management/actions",
  cohort: (id: string | number): string => `/cohorts/${id}`,
  cohorts: (): string => "/cohorts",
  cohortCalculationHistory: (id: string | number): string =>
    `/cohorts/${id}/calculation-history`,
  customerAnalytics: (): string => "/customer_analytics",
  customerAnalyticsConfiguration: (): string =>
    "/customer_analytics/configuration",
  dashboards: (): string => "/dashboard",
  dashboard: (id: string | number, highlightInsightId?: string): string =>
    combineUrl(
      `/dashboard/${id}`,
      highlightInsightId ? { highlightInsightId } : {},
    ).url,
  dashboardTextTile: (
    id: string | number,
    textTileId: string | number,
  ): string => `${urls.dashboard(id)}/text-tiles/${textTileId}`,
  dashboardSharing: (id: string | number): string => `/dashboard/${id}/sharing`,
  dashboardSubscriptions: (id: string | number): string =>
    `/dashboard/${id}/subscriptions`,
  dashboardSubscription: (
    id: string | number,
    subscriptionId: string,
  ): string => `/dashboard/${id}/subscriptions/${subscriptionId}`,
  sharedDashboard: (shareToken: string): string =>
    `/shared_dashboard/${shareToken}`,
  dataWarehouse: (): string => "/data-warehouse",
  earlyAccessFeatures: (): string => "/early_access_features",
  earlyAccessFeature: (id: string): string => `/early_access_features/${id}`,
  endpoints: (): string => "/endpoints",
  endpoint: (name: string): string => `/endpoints/${name}`,
  endpointsUsage: (params?: {
    dateFrom?: string;
    dateTo?: string;
    requestNameBreakdownEnabled?: string;
    requestNameFilter?: string[];
  }): string => {
    const queryParams = new URLSearchParams(params as Record<string, string>);
    const stringifiedParams = queryParams.toString();
    return `/endpoints/usage${stringifiedParams ? `?${stringifiedParams}` : ""}`;
  },
  errorTracking: (params = {}): string =>
    combineUrl("/error_tracking", params).url,
  errorTrackingConfiguration: (params = {}): string =>
    combineUrl("/error_tracking/configuration", params).url,
  errorTrackingIssue: (
    id: string,
    params: {
      timestamp?: string;
      fingerprint?: string;
    } = {},
  ): string => combineUrl(`/error_tracking/${id}`, params).url,
  errorTrackingIssueFingerprints: (id: string): string =>
    `/error_tracking/${id}/fingerprints`,
  errorTrackingAlert: (id: string): string => `/error_tracking/alerts/${id}`,
  errorTrackingAlertNew: (templateId: string): string =>
    `/error_tracking/alerts/new/${templateId}`,
  experiment: (
    id: string | number,
    formMode?: string | null,
    options?: {
      metric?: ExperimentMetric;
      name?: string;
    },
  ): string => {
    const baseUrl = formMode
      ? `/experiments/${id}/${formMode}`
      : `/experiments/${id}`;
    return `${baseUrl}${options ? `?${toParams(options)}` : ""}`;
  },
  experiments: (): string => "/experiments",
  experimentsSharedMetrics: (): string => "/experiments/shared-metrics",
  experimentsSharedMetric: (id: string | number, action?: string): string =>
    action
      ? `/experiments/shared-metrics/${id}/${action}`
      : `/experiments/shared-metrics/${id}`,
  featureFlags: (tab?: string): string =>
    `/feature_flags${tab ? `?tab=${tab}` : ""}`,
  featureFlag: (id: string | number): string => `/feature_flags/${id}`,
  featureFlagDuplicate: (sourceId: number | string | null): string =>
    `/feature_flags/new?sourceId=${sourceId}`,
  game368hedgehogs: (): string => `/games/368hedgehogs`,
  flappyHog: (): string => `/games/flappyhog`,
  groups: (groupTypeIndex: string | number): string =>
    `/groups/${groupTypeIndex}`,
  groupsNew: (groupTypeIndex: string | number): string =>
    `/groups/${groupTypeIndex}/new`,
  group: (
    groupTypeIndex: string | number,
    groupKey: string,
    encode: boolean = true,
    tab?: string | null,
  ): string =>
    `/groups/${groupTypeIndex}/${encode ? encodeURIComponent(groupKey) : groupKey}${tab ? `/${tab}` : ""}`,
  links: (): string => "/links",
  link: (id: string): string => `/link/${id}`,
  liveDebugger: (): string => "/live-debugger",
  llmAnalyticsDashboard: (): string => "/llm-analytics",
  llmAnalyticsGenerations: (): string => "/llm-analytics/generations",
  llmAnalyticsTraces: (): string => "/llm-analytics/traces",
  llmAnalyticsTrace: (
    id: string,
    params?: {
      event?: string;
      timestamp?: string;
      exception_ts?: string;
      search?: string;
      tab?: string;
    },
  ): string => {
    const queryParams = new URLSearchParams(params);
    const stringifiedParams = queryParams.toString();
    return `/llm-analytics/traces/${id}${stringifiedParams ? `?${stringifiedParams}` : ""}`;
  },
  llmAnalyticsUsers: (): string => "/llm-analytics/users",
  llmAnalyticsErrors: (): string => "/llm-analytics/errors",
  llmAnalyticsSessions: (): string => "/llm-analytics/sessions",
  llmAnalyticsSession: (
    id: string,
    params?: {
      timestamp?: string;
    },
  ): string => {
    const queryParams = new URLSearchParams(params);
    const stringifiedParams = queryParams.toString();
    return `/llm-analytics/sessions/${id}${stringifiedParams ? `?${stringifiedParams}` : ""}`;
  },
  llmAnalyticsPlayground: (): string => "/llm-analytics/playground",
  llmAnalyticsDatasets: (): string => "/llm-analytics/datasets",
  llmAnalyticsDataset: (
    id: string,
    params?: {
      item?: string;
    },
  ): string => combineUrl(`/llm-analytics/datasets/${id}`, params).url,
  llmAnalyticsEvaluations: (): string => "/llm-analytics/evaluations",
  llmAnalyticsEvaluationTemplates: (): string =>
    "/llm-analytics/evaluations/templates",
  llmAnalyticsEvaluation: (id: string): string =>
    `/llm-analytics/evaluations/${id}`,
  llmAnalyticsSettings: (): string => "/llm-analytics/settings",
  logs: (): string => "/logs",
  managedMigration: (): string => "/managed_migrations",
  managedMigrationNew: (): string => "/managed_migrations/new",
  marketingAnalyticsApp: (): string => "/marketing",
  notebooks: (): string => "/notebooks",
  notebook: (shortId: string): string => `/notebooks/${shortId}`,
  canvas: (): string => `/canvas`,
  personByDistinctId: (id: string, encode: boolean = true): string =>
    encode ? `/person/${encodeURIComponent(id)}` : `/person/${id}`,
  personByUUID: (uuid: string, encode: boolean = true): string =>
    encode ? `/persons/${encodeURIComponent(uuid)}` : `/persons/${uuid}`,
  persons: (): string => "/persons",
  insights: (): string => "/insights",
  insightNew: ({
    type,
    dashboardId,
    query,
    sceneSource,
  }: {
    type?: InsightType;
    dashboardId?: DashboardType["id"] | null;
    query?: Node;
    sceneSource?: InsightSceneSource;
  } = {}): string => {
    if (isHogQLQuery(query)) {
      return urls.sqlEditor(query.query);
    }
    if (
      (isDataVisualizationNode(query) || isDataTableNode(query)) &&
      isHogQLQuery(query.source)
    ) {
      return urls.sqlEditor(query.source.query);
    }
    return combineUrl(
      "/insights/new",
      dashboardId ? { dashboard: dashboardId } : {},
      {
        ...(type ? { insight: type } : {}),
        ...(query
          ? { q: typeof query === "string" ? query : JSON.stringify(query) }
          : {}),
        ...(sceneSource ? { sceneSource } : {}),
      },
    ).url;
  },
  insightNewHogQL: ({
    query,
    filters,
  }: {
    query: string;
    filters?: HogQLFilters;
  }): string =>
    urls.insightNew({
      query: {
        kind: NodeKind.DataTableNode,
        source: { kind: "HogQLQuery", query, filters },
      } as any,
    }),
  insightEdit: (id: InsightShortId): string => `/insights/${id}/edit`,
  insightView: (
    id: InsightShortId,
    dashboardId?: number,
    variablesOverride?: Record<string, HogQLVariable>,
    filtersOverride?: DashboardFilter,
    tileFiltersOverride?: TileFilters,
  ): string => {
    const params = [
      { param: "dashboard", value: dashboardId },
      { param: "variables_override", value: variablesOverride },
      { param: "filters_override", value: filtersOverride },
      { param: "tile_filters_override", value: tileFiltersOverride },
    ]
      .filter((n) => Boolean(n.value))
      .map((n) => `${n.param}=${encodeURIComponent(JSON.stringify(n.value))}`)
      .join("&");
    return `/insights/${id}${params.length ? `?${params}` : ""}`;
  },
  insightSubcriptions: (id: InsightShortId): string =>
    `/insights/${id}/subscriptions`,
  insightSubcription: (id: InsightShortId, subscriptionId: string): string =>
    `/insights/${id}/subscriptions/${subscriptionId}`,
  insightSharing: (id: InsightShortId): string => `/insights/${id}/sharing`,
  savedInsights: (tab?: string): string =>
    `/insights${tab ? `?tab=${tab}` : ""}`,
  insightAlerts: (insightShortId: InsightShortId): string =>
    `/insights/${insightShortId}/alerts`,
  insightAlert: (
    insightShortId: InsightShortId,
    alertId: AlertType["id"],
  ): string => `/insights/${insightShortId}/alerts?alert_id=${alertId}`,
  alert: (alertId: string): string =>
    `/insights?tab=alerts&alert_id=${alertId}`,
  alerts: (): string => `/insights?tab=alerts`,
  productTours: (): string => "/product_tours",
  productTour: (id: string): string => `/product_tours/${id}`,
  replay: (
    tab?: ReplayTabs,
    filters?: Partial<RecordingUniversalFilters>,
    sessionRecordingId?: string,
    order?: string,
  ): string =>
    combineUrl(tab ? `/replay/${tab}` : "/replay/home", {
      ...(filters ? { filters } : {}),
      ...(sessionRecordingId ? { sessionRecordingId } : {}),
      ...(order ? { order } : {}),
    }).url,
  replayPlaylist: (id: string): string => `/replay/playlists/${id}`,
  replaySingle: (
    id: string,
    options?: {
      secondsOffsetFromStart?: number;
      unixTimestampMillis?: number;
    },
  ): string => {
    if (options?.unixTimestampMillis) {
      return `/replay/${id}?timestamp=${options.unixTimestampMillis}`;
    }
    if (options?.secondsOffsetFromStart) {
      return `/replay/${id}?t=${options.secondsOffsetFromStart}`;
    }
    return `/replay/${id}`;
  },
  replayFilePlayback: (): string => "/replay/file-playback",
  replaySettings: (sectionId?: string): string =>
    `/replay/settings${sectionId ? `?sectionId=${sectionId}` : ""}`,
  revenueAnalytics: (): string => "/revenue_analytics",
  sessionSummaries: (): string => "/session-summaries",
  sessionSummary: (sessionGroupId: string): string =>
    `/session-summaries/${sessionGroupId}`,
  surveys: (tab?: SurveysTabs): string => `/surveys${tab ? `?tab=${tab}` : ""}`,
  survey: (id: string): string => `/surveys/${id}`,
  surveyTemplates: (): string => "/survey_templates",
  taskTracker: (): string => "/tasks",
  taskDetail: (taskId: string | number): string => `/tasks/${taskId}`,
  userInterviews: (): string => "/user_interviews",
  userInterview: (id: string): string => `/user_interviews/${id}`,
  webAnalytics: (): string => `/web`,
  webAnalyticsWebVitals: (): string => `/web/web-vitals`,
  webAnalyticsPageReports: (): string => `/web/page-reports`,
  webAnalyticsMarketing: (): string => `/web/marketing`,
  webAnalyticsHealth: (): string => `/web/health`,
  workflows: (tab?: WorkflowsSceneTab): string =>
    `/workflows${tab ? `/${tab}` : ""}`,
  workflow: (id: string, tab: string): string => `/workflows/${id}/${tab}`,
  workflowNew: (): string => "/workflows/new/workflow",
  workflowsLibraryMessage: (id: string): string =>
    `/workflows/library/messages/${id}`,
  workflowsLibraryTemplate: (id?: string): string =>
    `/workflows/library/templates/${id}`,
  workflowsLibraryTemplateNew: (): string => "/workflows/library/templates/new",
  workflowsLibraryTemplateFromMessage: (id?: string): string =>
    `/workflows/library/templates/new?messageId=${id}`,
};

/** This const is auto-generated, as is the whole file */
export const fileSystemTypes = {
  action: {
    name: "Action",
    href: (ref: string) => urls.action(ref),
    filterKey: "action",
    iconType: "action" as FileSystemIconType,
    iconColor: ["var(--color-product-actions-light)"] as FileSystemIconColor,
  },
  cohort: {
    name: "Cohort",
    iconType: "cohort" as FileSystemIconType,
    href: (ref: string) => urls.cohort(ref),
    filterKey: "cohort",
    iconColor: ["var(--color-product-cohorts-light)"] as FileSystemIconColor,
  },
  dashboard: {
    name: "Dashboard",
    iconType: "dashboard" as FileSystemIconType,
    href: (ref: string) => urls.dashboard(ref),
    iconColor: ["var(--color-product-dashboards-light)"],
    filterKey: "dashboard",
  },
  early_access_feature: {
    name: "Early access feature",
    iconType: "early_access_feature" as FileSystemIconType,
    href: (ref: string) => urls.earlyAccessFeature(ref),
    iconColor: [
      "var(--color-product-early-access-features-light)",
      "var(--color-product-early-access-features-dark)",
    ],
    filterKey: "early_access_feature",
  },
  endpoints: {
    name: "Endpoints",
    iconType: "endpoints",
    href: () => urls.endpoints(),
    iconColor: ["var(--color-product-endpoints-light)"],
    filterKey: "endpoints",
    flag: FEATURE_FLAGS.ENDPOINTS,
  },
  experiment: {
    name: "Experiment",
    iconType: "experiment",
    href: (ref: string) => urls.experiment(ref),
    iconColor: ["var(--color-product-experiments-light)"],
    filterKey: "experiment",
  },
  feature_flag: {
    name: "Feature flag",
    iconType: "feature_flag",
    href: (ref: string) => urls.featureFlag(ref),
    iconColor: ["var(--color-product-feature-flags-light)"],
    filterKey: "feature_flag",
  },
  insight: {
    name: "Insight",
    iconType: "product_analytics",
    href: (ref: string) => urls.insightView(ref as InsightShortId),
    iconColor: ["var(--color-product-product-analytics-light)"],
    filterKey: "insight",
  },
  link: {
    name: "Link",
    iconType: "link" as FileSystemIconType,
    href: (ref: string) => urls.link(ref),
    iconColor: ["var(--color-product-links-light)"],
    filterKey: "link",
    flag: FEATURE_FLAGS.LINKS,
  },
  live_debugger: {
    name: "Live Debugger",
    iconType: "live_debugger",
    href: () => urls.liveDebugger(),
    iconColor: ["var(--color-product-live-debugger-light)"],
    filterKey: "live_debugger",
    flag: FEATURE_FLAGS.LIVE_DEBUGGER,
  },
  notebook: {
    name: "Notebook",
    iconType: "notebook",
    href: (ref: string) => urls.notebook(ref),
    filterKey: "notebook",
  },
  product_tour: {
    name: "Product tour",
    iconType: "product_tour",
    href: (ref: string) => urls.productTour(ref),
    iconColor: ["var(--color-product-surveys-light)"],
    filterKey: "product_tour",
  },
  revenue: {
    name: "Revenue",
    iconType: "revenue_analytics" as FileSystemIconType,
    href: () => urls.revenueAnalytics(),
    iconColor: [
      "var(--color-product-revenue-analytics-light)",
      "var(--color-product-revenue-analytics-dark)",
    ],
    filterKey: "revenue",
  },
  session_recording_playlist: {
    name: "Replay playlist",
    iconType: "session_replay",
    href: (ref: string) => urls.replayPlaylist(ref),
    iconColor: [
      "var(--color-product-session-replay-light)",
      "var(--color-product-session-replay-dark)",
    ],
    filterKey: "session_recording_playlist",
  },
  survey: {
    name: "Survey",
    iconType: "survey",
    href: (ref: string) => urls.survey(ref),
    iconColor: ["var(--color-product-surveys-light)"],
    filterKey: "survey",
  },
  task: {
    name: "Task",
    iconType: "task",
    href: () => urls.taskTracker(),
    iconColor: ["var(--product-tasks-light)", "var(--product-tasks-dark)"],
    filterKey: "task",
    flag: FEATURE_FLAGS.TASKS,
  },
  user_interview: {
    name: "User interview",
    iconType: "user_interview",
    href: (ref: string) => urls.userInterview(ref),
    iconColor: ["var(--color-product-user-interviews-light)"],
    filterKey: "user_interview",
    flag: FEATURE_FLAGS.USER_INTERVIEWS,
  },
  workflows: {
    name: "Workflow",
    iconType: "workflows",
    iconColor: ["var(--color-product-workflows-light)"] as FileSystemIconColor,
    href: (ref: string) => urls.workflow(ref, "workflow"),
    filterKey: "workflows",
  },
};

/** This const is auto-generated, as is the whole file */
export const getTreeItemsNew = (): FileSystemImport[] => [
  {
    type: "action",
    path: "Action",
    href: urls.createAction(),
    iconType: "action" as FileSystemIconType,
    iconColor: ["var(--color-product-actions-light)"] as FileSystemIconColor,
  },
  {
    path: `Cohort`,
    type: "cohort",
    href: urls.cohort("new"),
    iconType: "cohort" as FileSystemIconType,
    iconColor: ["var(--color-product-cohorts-light)"] as FileSystemIconColor,
    sceneKeys: ["Cohorts", "Cohort"],
  },
  {
    path: `Dashboard`,
    type: "dashboard",
    href: urls.dashboards() + "#newDashboard=modal",
    iconType: "dashboard" as FileSystemIconType,
    iconColor: ["var(--color-product-dashboards-light)"] as FileSystemIconColor,
    sceneKey: "Dashboard",
    sceneKeys: ["Dashboards", "Dashboard"],
  },
  {
    path: `Data/Destination`,
    type: "hog_function/destination",
    href: urls.dataPipelinesNew("destination"),
    iconColor: ["var(--color-product-data-pipeline-light)"],
    sceneKeys: ["HogFunction"],
  },
  {
    path: `Data/Site app`,
    type: "hog_function/site_app",
    href: urls.dataPipelinesNew("site_app"),
    iconColor: ["var(--color-product-data-pipeline-light)"],
    sceneKeys: ["HogFunction"],
  },
  {
    path: `Data/Source`,
    type: "hog_function/source",
    href: urls.dataPipelinesNew("source"),
    iconColor: ["var(--color-product-data-pipeline-light)"],
    sceneKeys: ["HogFunction"],
  },
  {
    path: `Data/Transformation`,
    type: "hog_function/transformation",
    href: urls.dataPipelinesNew("transformation"),
    iconColor: ["var(--color-product-data-pipeline-light)"],
    sceneKeys: ["HogFunction"],
  },
  {
    path: `Early access feature`,
    type: "early_access_feature",
    href: urls.earlyAccessFeature("new"),
    iconType: "early_access_feature" as FileSystemIconType,
    iconColor: [
      "var(--color-product-early-access-features-light)",
      "var(--color-product-early-access-features-dark)",
    ] as FileSystemIconColor,
  },
  {
    path: `Experiment`,
    type: "experiment",
    href: urls.experiment("new"),
    iconType: "experiment",
    iconColor: [
      "var(--color-product-experiments-light)",
    ] as FileSystemIconColor,
    sceneKeys: ["Experiments", "Experiment"],
  },
  {
    path: `Feature flag`,
    type: "feature_flag",
    href: urls.featureFlag("new"),
    iconType: "feature_flag",
    iconColor: [
      "var(--color-product-feature-flags-light)",
    ] as FileSystemIconColor,
  },
  {
    path: `Insight/Funnel`,
    type: "insight",
    href: urls.insightNew({ type: InsightType.FUNNELS }),
    iconType: "insight/funnels",
    iconColor: ["var(--color-insight-funnel-light)"] as FileSystemIconColor,
    visualOrder: INSIGHT_VISUAL_ORDER.funnel,
    sceneKeys: ["Insight"],
  },
  {
    path: `Insight/Lifecycle`,
    type: "insight",
    href: urls.insightNew({ type: InsightType.LIFECYCLE }),
    iconType: "insight/lifecycle",
    iconColor: ["var(--color-insight-lifecycle-light)"] as FileSystemIconColor,
    visualOrder: INSIGHT_VISUAL_ORDER.lifecycle,
    sceneKeys: ["Insight"],
  },
  {
    path: `Insight/Retention`,
    type: "insight",
    href: urls.insightNew({ type: InsightType.RETENTION }),
    iconType: "insight/retention",
    iconColor: ["var(--color-insight-retention-light)"] as FileSystemIconColor,
    visualOrder: INSIGHT_VISUAL_ORDER.retention,
    sceneKeys: ["Insight"],
  },
  {
    path: `Insight/Stickiness`,
    type: "insight",
    href: urls.insightNew({ type: InsightType.STICKINESS }),
    iconType: "insight/stickiness",
    iconColor: ["var(--color-insight-stickiness-light)"] as FileSystemIconColor,
    visualOrder: INSIGHT_VISUAL_ORDER.stickiness,
    sceneKeys: ["Insight"],
  },
  {
    path: `Insight/Trends`,
    type: "insight",
    href: urls.insightNew({ type: InsightType.TRENDS }),
    iconType: "insight/trends",
    iconColor: ["var(--color-insight-trends-light)"] as FileSystemIconColor,
    visualOrder: INSIGHT_VISUAL_ORDER.trends,
    sceneKeys: ["Insight"],
  },
  {
    path: `Insight/User paths`,
    type: "insight",
    href: urls.insightNew({ type: InsightType.PATHS }),
    iconType: "insight/paths",
    iconColor: [
      "var(--color-insight-user-paths-light)",
      "var(--color-user-paths-dark)",
    ] as FileSystemIconColor,
    visualOrder: INSIGHT_VISUAL_ORDER.paths,
    sceneKeys: ["Insight"],
  },
  {
    path: `Link`,
    type: "link",
    href: urls.link("new"),
    iconType: "link" as FileSystemIconType,
    iconColor: ["var(--color-product-links-light)"] as FileSystemIconColor,
    flag: FEATURE_FLAGS.LINKS,
  },
  {
    path: `Notebook`,
    type: "notebook",
    href: urls.notebook("new"),
    iconType: "notebook",
  },
  {
    path: `Product tour`,
    type: "product_tour",
    href: urls.productTour("new"),
    iconType: "product_tour",
    iconColor: ["var(--color-product-surveys-light)"] as FileSystemIconColor,
  },
  {
    path: `Survey`,
    type: "survey",
    href: urls.survey("new"),
    iconType: "survey",
    iconColor: ["var(--color-product-surveys-light)"] as FileSystemIconColor,
  },
];

/** This const is auto-generated, as is the whole file */
export const getTreeItemsProducts = (): FileSystemImport[] => [
  {
    path: "Customer analytics",
    intents: [ProductKey.CUSTOMER_ANALYTICS],
    category: "Analytics",
    iconType: "cohort",
    href: urls.customerAnalytics(),
    tags: ["alpha"],
    flag: FEATURE_FLAGS.CUSTOMER_ANALYTICS,
    sceneKey: "CustomerAnalytics",
    sceneKeys: ["CustomerAnalytics", "CustomerAnalyticsConfiguration"],
  },
  {
    path: "Dashboards",
    intents: [ProductKey.PRODUCT_ANALYTICS],
    category: "Analytics",
    type: "dashboard",
    iconType: "dashboard",
    iconColor: ["var(--color-product-dashboards-light)"],
    href: urls.dashboards(),
    sceneKey: "Dashboards",
    sceneKeys: ["Dashboard", "Dashboards"],
  },
  {
    path: `Data pipelines`,
    category: "Tools",
    type: "hog_function",
    iconType: "data_pipeline",
    iconColor: ["var(--color-product-data-pipeline-light)"],
    href: urls.dataPipelines(),
    sceneKey: "DataPipelines",
    sceneKeys: ["DataPipelines"],
  },
  {
    path: "Data warehouse",
    intents: [ProductKey.DATA_WAREHOUSE, ProductKey.DATA_WAREHOUSE_SAVED_QUERY],
    category: "Unreleased",
    href: urls.dataWarehouse(),
    flag: FEATURE_FLAGS.DATA_WAREHOUSE_SCENE,
    iconType: "data_warehouse",
    iconColor: ["var(--color-product-data-warehouse-light)"],
    sceneKey: "DataWarehouse",
    sceneKeys: ["DataWarehouse", "SQLEditor"],
  },
  {
    path: "Early access features",
    intents: [ProductKey.EARLY_ACCESS_FEATURES],
    category: "Features",
    type: "early_access_feature",
    href: urls.earlyAccessFeatures(),
    iconType: "early_access_feature" as FileSystemIconType,
    iconColor: [
      "var(--color-product-early-access-features-light)",
      "var(--color-product-early-access-features-dark)",
    ] as FileSystemIconColor,
    sceneKey: "EarlyAccessFeatures",
    sceneKeys: ["EarlyAccessFeatures", "EarlyAccessFeature"],
  },
  {
    path: "Endpoints",
    intents: [ProductKey.ENDPOINTS],
    category: "Unreleased",
    href: urls.endpoints(),
    type: "endpoints",
    flag: FEATURE_FLAGS.ENDPOINTS,
    tags: ["beta"],
    iconType: "endpoints",
    iconColor: ["var(--color-product-endpoints-light)"] as FileSystemIconColor,
    sceneKey: "EndpointsScene",
    sceneKeys: ["EndpointsScene", "EndpointsUsage", "EndpointScene"],
  },
  {
    path: "Error tracking",
    intents: [ProductKey.ERROR_TRACKING],
    category: "Behavior",
    type: "error_tracking",
    iconType: "error_tracking" as FileSystemIconType,
    iconColor: [
      "var(--color-product-error-tracking-light)",
      "var(--color-product-error-tracking-dark)",
    ] as FileSystemIconColor,
    href: urls.errorTracking(),
    sceneKey: "ErrorTracking",
    sceneKeys: [
      "ErrorTracking",
      "ErrorTrackingIssue",
      "ErrorTrackingIssueFingerprints",
      "ErrorTrackingConfiguration",
    ],
  },
  {
    path: `Experiments`,
    intents: [ProductKey.EXPERIMENTS],
    category: "Features",
    type: "experiment",
    href: urls.experiments(),
    iconType: "experiment",
    iconColor: [
      "var(--color-product-experiments-light)",
    ] as FileSystemIconColor,
    sceneKey: "Experiments",
    sceneKeys: ["Experiments", "Experiment"],
  },
  {
    path: `Feature flags`,
    intents: [
      ProductKey.FEATURE_FLAGS,
      ProductKey.EXPERIMENTS,
      ProductKey.EARLY_ACCESS_FEATURES,
    ],
    category: "Features",
    type: "feature_flag",
    href: urls.featureFlags(),
    sceneKey: "FeatureFlags",
    sceneKeys: ["FeatureFlags", "FeatureFlag"],
  },
  {
    path: "Heatmaps",
    intents: [ProductKey.HEATMAPS],
    category: "Behavior",
    iconType: "heatmap",
    iconColor: [
      "var(--color-product-heatmaps-light)",
      "var(--color-product-heatmaps-dark)",
    ],
    href: urls.heatmaps(),
    tags: ["beta"],
    sceneKey: "Heatmaps",
    sceneKeys: ["Heatmaps"],
  },
  {
    path: "LLM analytics",
    intents: [ProductKey.LLM_ANALYTICS],
    category: "Analytics",
    iconType: "llm_analytics" as FileSystemIconType,
    iconColor: [
      "var(--color-product-llm-analytics-light)",
    ] as FileSystemIconColor,
    href: urls.llmAnalyticsDashboard(),
    sceneKey: "LLMAnalytics",
    sceneKeys: [
      "LLMAnalytics",
      "LLMAnalyticsTrace",
      "LLMAnalyticsSession",
      "LLMAnalyticsUsers",
      "LLMAnalyticsPlayground",
      "LLMAnalyticsDatasets",
      "LLMAnalyticsDataset",
      "LLMAnalyticsEvaluations",
      "LLMAnalyticsEvaluation",
      "LLMAnalyticsEvaluationTemplates",
    ],
  },
  {
    path: "Links",
    intents: [ProductKey.LINKS],
    category: "Unreleased",
    type: "link",
    href: urls.links(),
    flag: FEATURE_FLAGS.LINKS,
    tags: ["alpha"],
    sceneKey: "Links",
    sceneKeys: ["Links", "Link"],
  },
  {
    path: "Live Debugger",
    intents: [ProductKey.LIVE_DEBUGGER],
    category: "Unreleased",
    type: "live_debugger",
    href: urls.liveDebugger(),
    flag: FEATURE_FLAGS.LIVE_DEBUGGER,
    iconType: "live_debugger",
    tags: ["alpha"],
    iconColor: [
      "var(--color-product-live-debugger-light)",
    ] as FileSystemIconColor,
    sceneKeys: ["LiveDebugger"],
  },
  {
    path: "Logs",
    intents: [ProductKey.LOGS],
    category: "Behavior",
    iconType: "logs" as FileSystemIconType,
    iconColor: ["var(--color-product-logs-light)"] as FileSystemIconColor,
    href: urls.logs(),
    flag: FEATURE_FLAGS.LOGS_PRE_EARLY_ACCESS,
    tags: ["beta"],
    sceneKey: "Logs",
    sceneKeys: ["Logs"],
  },
  {
    path: "Marketing analytics",
    intents: [ProductKey.MARKETING_ANALYTICS],
    category: "Analytics",
    href: urls.marketingAnalyticsApp(),
    iconType: "marketing_analytics" as FileSystemIconType,
    iconColor: [
      "var(--color-product-marketing-analytics-light)",
    ] as FileSystemIconColor,
    tags: ["beta"],
    flag: FEATURE_FLAGS.WEB_ANALYTICS_MARKETING,
    sceneKey: "MarketingAnalytics",
    sceneKeys: ["MarketingAnalytics"],
  },
  {
    path: "Notebooks",
    category: "Tools",
    type: "notebook",
    iconType: "notebook",
    href: urls.notebooks(),
    sceneKey: "Notebooks",
    sceneKeys: ["Notebook", "Notebooks"],
  },
  {
    path: "Product analytics",
    intents: [ProductKey.PRODUCT_ANALYTICS],
    category: "Analytics",
    type: "insight",
    href: urls.insights(),
    iconType: "product_analytics",
    iconColor: ["var(--color-product-product-analytics-light)"],
    sceneKey: "SavedInsights",
    sceneKeys: ["SavedInsights", "Insight"],
  },
  {
    path: "Product tours",
    category: "Behavior",
    type: "product_tour",
    href: urls.productTours(),
    iconType: "product_tour",
    iconColor: ["var(--color-product-surveys-light)"] as FileSystemIconColor,
    sceneKey: "ProductTours",
    sceneKeys: ["ProductTour", "ProductTours"],
    flag: FEATURE_FLAGS.PRODUCT_TOURS,
  },
  {
    path: "Revenue analytics",
    intents: [ProductKey.REVENUE_ANALYTICS],
    category: "Analytics",
    href: urls.revenueAnalytics(),
    type: "revenue",
    tags: ["beta"],
    sceneKey: "RevenueAnalytics",
    sceneKeys: ["RevenueAnalytics"],
  },
  {
    path: "SQL editor",
    intents: [ProductKey.DATA_WAREHOUSE_SAVED_QUERY, ProductKey.DATA_WAREHOUSE],
    category: "Analytics",
    type: "sql",
    iconType: "sql_editor",
    iconColor: ["var(--color-product-data-warehouse-light)"],
    href: urls.sqlEditor(),
    sceneKey: "SQLEditor",
    sceneKeys: ["SQLEditor"],
  },
  {
    path: "Session replay",
    intents: [ProductKey.SESSION_REPLAY, ProductKey.MOBILE_REPLAY],
    category: "Behavior",
    href: urls.replay(ReplayTabs.Home),
    type: "session_recording_playlist",
    iconType: "session_replay",
    iconColor: [
      "var(--color-product-session-replay-light)",
      "var(--color-product-session-replay-dark)",
    ],
    sceneKey: "Replay",
    sceneKeys: [
      "Replay",
      "ReplaySingle",
      "ReplaySettings",
      "ReplayPlaylist",
      "ReplayFilePlayback",
    ],
  },
  {
    path: "Surveys",
    intents: [ProductKey.SURVEYS],
    category: "Behavior",
    type: "survey",
    href: urls.surveys(),
    iconType: "survey",
    iconColor: ["var(--color-product-surveys-light)"] as FileSystemIconColor,
    sceneKey: "Surveys",
    sceneKeys: ["Survey", "Surveys"],
  },
  {
    path: "Tasks",
    category: "Unreleased",
    type: "task",
    href: urls.taskTracker(),
    flag: FEATURE_FLAGS.TASKS,
    iconType: "task",
    tags: ["alpha"],
    iconColor: [
      "var(--product-tasks-light)",
      "var(--product-tasks-dark)",
    ] as FileSystemIconColor,
    sceneKey: "TaskTracker",
    sceneKeys: ["TaskTracker", "TaskDetail"],
  },
  {
    path: "User interviews",
    intents: [ProductKey.USER_INTERVIEWS],
    category: "Unreleased",
    href: urls.userInterviews(),
    type: "user_interview",
    flag: FEATURE_FLAGS.USER_INTERVIEWS,
    tags: ["alpha"],
    iconType: "user_interview",
    iconColor: [
      "var(--color-product-user-interviews-light)",
    ] as FileSystemIconColor,
    sceneKey: "UserInterviews",
    sceneKeys: ["UserInterviews", "UserInterview"],
  },
  {
    path: "Web analytics",
    intents: [ProductKey.WEB_ANALYTICS],
    category: "Analytics",
    iconType: "web_analytics",
    iconColor: [
      "var(--color-product-web-analytics-light)",
    ] as FileSystemIconColor,
    href: urls.webAnalytics(),
    sceneKey: "WebAnalytics",
    sceneKeys: ["WebAnalytics"],
  },
  {
    path: "Workflows",
    intents: [ProductKey.WORKFLOWS],
    href: urls.workflows(),
    type: "workflows",
    category: "Tools",
    tags: ["beta"],
    flag: FEATURE_FLAGS.WORKFLOWS,
    iconType: "workflows",
    iconColor: ["var(--color-product-workflows-light)"] as FileSystemIconColor,
    sceneKey: "Workflows",
    sceneKeys: ["Workflows", "Workflow", "WorkflowsLibraryTemplate"],
  },
];

/** This const is auto-generated, as is the whole file */
export const getTreeItemsGames = (): FileSystemImport[] => [
  { path: "368 Hedgehogs", href: urls.game368hedgehogs() },
  { path: "Flappy Hog", href: "/games/flappyhog" },
];

/** This const is auto-generated, as is the whole file */
export const getTreeItemsMetadata = (): FileSystemImport[] => [
  {
    path: "Actions",
    category: "Schema",
    href: urls.actions(),
    iconType: "action" as FileSystemIconType,
    sceneKey: "Actions",
    sceneKeys: ["Actions", "Action", "NewAction"],
  },
  {
    path: "Annotations",
    category: "Metadata",
    iconType: "annotation",
    href: urls.annotations(),
    sceneKey: "Annotations",
    sceneKeys: ["Annotations"],
  },
  {
    path: "Comments",
    category: "Metadata",
    iconType: "comment",
    href: urls.comments(),
    sceneKey: "Comments",
    sceneKeys: ["Comments"],
  },
  {
    path: "Data pipelines",
    category: "Tools",
    type: "hog_function",
    iconType: "data_pipeline",
    iconColor: ["var(--color-product-data-pipeline-light)"],
    href: urls.dataPipelines(),
    sceneKey: "DataPipelines",
    sceneKeys: ["DataPipelines"],
  },
  {
    path: `Destinations`,
    category: "Pipeline",
    type: "hog_function/destination",
    iconType: "data_pipeline_metadata",
    href: urls.dataPipelines("destinations"),
    sceneKey: "DataPipelines",
    sceneKeys: ["DataPipelines"],
  },
  {
    path: "Endpoints",
    category: "Unreleased",
    iconType: "endpoints" as FileSystemIconType,
    iconColor: ["var(--color-product-endpoints-light)"] as FileSystemIconColor,
    href: urls.endpoints(),
    sceneKey: "EndpointsScene",
    flag: FEATURE_FLAGS.ENDPOINTS,
    tags: ["beta"],
    sceneKeys: ["EndpointsScene", "EndpointsUsage", "EndpointScene"],
  },
  {
    path: "Event definitions",
    category: "Schema",
    iconType: "event_definition",
    href: urls.eventDefinitions(),
    sceneKey: "EventDefinitions",
    sceneKeys: ["EventDefinition", "EventDefinitions"],
  },
  {
    path: "Ingestion warnings",
    category: "Pipeline",
    iconType: "ingestion_warning",
    href: urls.ingestionWarnings(),
    sceneKey: "IngestionWarnings",
    sceneKeys: ["IngestionWarnings"],
  },
  {
    path: "Managed viewsets",
    category: "Unreleased",
    iconType: "managed_viewsets",
    href: urls.dataWarehouseManagedViewsets(),
    flag: FEATURE_FLAGS.MANAGED_VIEWSETS,
    sceneKeys: ["DataWarehouse", "SQLEditor"],
  },
  {
    path: "Marketing settings",
    category: "Unreleased",
    iconType: "marketing_settings",
    href: urls.marketingAnalytics(),
    flag: FEATURE_FLAGS.WEB_ANALYTICS_MARKETING,
    sceneKey: "WebAnalyticsMarketing",
    sceneKeys: ["WebAnalyticsMarketing"],
  },
  {
    path: "Property definitions",
    category: "Schema",
    iconType: "property_definition",
    href: urls.propertyDefinitions(),
    sceneKey: "PropertyDefinitions",
    sceneKeys: ["PropertyDefinition", "PropertyDefinitions"],
  },
  {
    path: "Property groups",
    category: "Schema",
    iconType: "event_definition",
    href: urls.schemaManagement(),
    flag: FEATURE_FLAGS.SCHEMA_MANAGEMENT,
    sceneKeys: [],
  },
  {
    path: "Revenue definitions",
    category: "Schema",
    iconType: "revenue_analytics_metadata" as FileSystemIconType,
    href: urls.revenueSettings(),
    sceneKey: "RevenueAnalytics",
    sceneKeys: ["RevenueAnalytics"],
  },
  {
    path: `Sources`,
    category: "Pipeline",
    type: "hog_function/source",
    iconType: "data_pipeline_metadata",
    href: urls.dataPipelines("sources"),
    sceneKey: "DataPipelines",
    sceneKeys: ["DataPipelines"],
  },
  {
    path: `Transformations`,
    category: "Pipeline",
    type: "hog_function/transformation",
    iconType: "data_pipeline_metadata",
    href: urls.dataPipelines("transformations"),
    sceneKey: "DataPipelines",
    sceneKeys: ["DataPipelines"],
  },
];
